import { useTranslation } from 'react-i18next'
import { AxiosError } from 'axios'

import LoadingSection from '../LoadingSection/LoadingSection'
import NotFound from '../NotFound/NotFound'

interface IRequestStateHandlerProps {
    state: { loading?: boolean; error?: AxiosError }
}

function RequestStateHandler(props: IRequestStateHandlerProps) {
    const { loading, error } = props.state
    const { t } = useTranslation()

    if (loading || (error && error.code === 'ERR_CANCELED')) {
        return <LoadingSection />
    }

    if (error) {
        return <div>{error.message}</div>
    }

    return <NotFound title={t('no_data')} />
}

export default RequestStateHandler
